import React, { useState } from 'react';
import ProposalLawyer from './ProposalLawyer';
import ProposalCover from './ProposalCover';
import ProposalData from './ProposalData';
import ProposalSelection from './ProposalSelection';
import ProposalBackCover from './ProposalBackCover';
import ProposalPreview from './ProposalPreview';

const CreateProposal = ({ setCreateView }) => {
  // const [step, setStep] = useState(0);
  const [step, setStep] = useState(0);
  const [pdfValue, setPdfValue] = useState('');

  return (
    <>
      {step === 0 && (
        <ProposalSelection setStep={setStep} setCreateView={setCreateView} />
      )}
      {step === 1 && (
        <ProposalLawyer setStep={setStep} setCreateView={setCreateView} />
      )}
      {step === 2 && (
        <ProposalCover setStep={setStep} setCreateView={setCreateView} />
      )}
      {step === 3 && (
        <ProposalData setStep={setStep} setCreateView={setCreateView} />
      )}
      {step === 4 && (
        <ProposalBackCover setStep={setStep} setCreateView={setCreateView} setPdfValue={setPdfValue} />
      )}
      {step === 5 && <ProposalPreview setStep={setStep} pdfValue={pdfValue} setCreateView={setCreateView} />}
    </>
  );
};

export default CreateProposal;
